/* src/app/modules/portal/components/docBoxPanel/docBoxPanel.component.scss */
.empty {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
}
.panel-entry {
  padding-bottom: 1rem;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.panel-entry:last-of-type {
  border-bottom: none;
}
.panel-entry .truncated-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
}
.panel-entry .title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  text-decoration: underline;
  flex-direction: row;
  align-items: center;
}
.panel-entry .title sh-icon,
.panel-entry .title sh-spinner {
  margin-right: 0.5rem;
  max-width: calc(32px + 0.5rem);
}
.panel-entry .dates {
  align-items: center;
  color: var(--text-secondary);
  line-height: 1rem;
  font-size: 0.75rem;
  display: flex;
  flex-direction: row;
}
.panel-entry .dates .tag {
  border: var(--sh-tag-wrapper-border) solid rgba(var(--ui-1), var(--opacity-5));
  padding: 0.25rem;
}
/*# sourceMappingURL=docBoxPanel.component.css.map */
